import { render, staticRenderFns } from "./TicketAlertsAudio.vue?vue&type=template&id=77dd8473&"
import script from "./TicketAlertsAudio.vue?vue&type=script&lang=js&"
export * from "./TicketAlertsAudio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports